/**
 * @file LockedRow.tsx
 * @description Строка «всегда на сайте» с замком (phase19.16 Р1; SB17, SB67;
 * uiux-design-r1 §2): то, что ставит платформа и выключить нельзя.
 */

import { Lock } from "lucide-react";
import type { ReactNode } from "react";

export function LockedRow({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-12 items-center gap-3">
      <Lock aria-hidden className="size-4 shrink-0 text-on-surface-variant" />
      <span className="type-body text-on-surface">{children}</span>
      <span className="sr-only">— ставит платформа, выключить нельзя</span>
    </div>
  );
}
